export default function ArrowLeft(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 2.85938C17.3906 3.375 17.3906 4.17188 16.875 4.64062L9.5625 12L16.875 19.3594C17.3906 19.8281 17.3906 20.625 16.875 21.0938C16.4062 21.6094 15.6094 21.6094 15.0938 21.0938L6.70312 12.7031C6.32812 12.3281 6.32812 11.6719 6.70312 11.2969L15.0938 2.85938C15.6094 2.39062 16.4062 2.39062 16.875 2.85938Z"
        fill="white"
      />
    </svg>
  );
}
